//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import Autocomplete from '@material-ui/lab/Autocomplete';

// custom pages
import 'assets/css/custom.css';
import redeem from 'apis/redeem/redeem';
import Context from 'context/context';
import { redeemStyles } from './styles';
import Loader from 'components/Loader/Loader';
import NoData from 'components/Table/NoData';
import dashboard from 'apis/dashboard/dashboard';
import Gold from 'assets/img/gold-level.png';
import Silver from 'assets/img/silver-level.png';
import Platinum from 'assets/img/platinum-level.png';
import Bronze from 'assets/img/bronze-level.png';
import access from 'config/access';
import PointsCard from 'views/Dashboard/Dashboard/Components/PointsCard';
import { currencyFormat } from "helpers/dataFormat"

//analytics
import { logEvent } from "../../../helpers/analytics";
import {useTrackWithGTM} from 'helpers/gtm';



// material-ui
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { blockInvalidChar } from 'helpers/blockInvalidChar';
// material-ui icons

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#616161',
    },
  },
});

const GlobalCss = withStyles({
  '@global': {
    '.MuiFormLabel-root': {
      fontSize: 19,
      color: 'black',
    },
    '.MuiTooltip-tooltip': {
      fontSize: 20,
    },
    '.MuiOutlinedInput-input': {
      textAlign: 'right',
      background: '#f6f9fc !important',
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child':
    {
      paddingLeft: 20,
    },
  },
})(() => null);

export default function Redemption() {
  const { state, dispatch } = useContext(Context);
  const history = useHistory();
  const classes = redeemStyles();
  const { t, i18n } = useTranslation();

  const { getPoints, getBillingAccount } = dashboard();
  const { confirmRedeem, getBillingAccountRedeem, allowRedeem, getShiptoList } = redeem();
  const { trackWithGTM } = useTrackWithGTM()
  const toastCss = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
  };

  const [states, setstates] = useState({
    billtoAccounts: [],
    availablePoints: 0,
    selectedCard: 0,
    selectedAccount: {},
    total_points: 0,
    pointsEntered: '',
    dollorValue: 0,
    errorText: '',
    qualifiedPoints: 0,
    billingAccount: {},
    pointsToDollor: 0.0,
    availableToRedeem: 0,
    redeemBtnDisabled: false,
    maxRedemptionPoints: 0,
    shiptoSearch: '',
    shiptoLoading: false,
    shiptoList: [],
    shiptoErrorText: '',
    onewebshipto: ''
  });


  const [loading, setLoading] = useState(false);
  

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      if (state?.ALA?.['Loyalty_Account.is_active']) {
        return;
      } else {
        history.push('/dashboard/loyalty');
      }
    }
  }, [state.ALA]);

  useEffect(() => {
    dispatch({ type: 'SET_PATHNAME', payload: ['HOME', 'Redeem My Points'] });
  }, []);

  useEffect(() => {
    handleMarketingAdminFunc();
    handleAllowRedeem();
  }, [state.ALA]);

  console.log(state.ALA,"state.ALA")

  const handleAllowRedeem = async () => {
    let res = await allowRedeem()
    if (res?.type?.toLowerCase() === 'error') {
      toast.error(
        res && res.message ? toastHandler(res) : t('Something Went Wrong'),
        toastCss
      );
      history.goBack()
    }
  }

  const handleMarketingAdminFunc = () => {
    if (access["myDashboard"]["loyalty"][state.userInfo.role]) {
      if (state?.ALA && Object.keys(state?.ALA).length > 0) {
        return;
      }
      return history.push("/dashboard/loyalty");
    }
  };

  // handling points api call
  useEffect(() => {
    if (state.ALA && Object.keys(state.ALA).length > 0) {
      handleGetBillingAccount();
      handleGetBillingAccountRedeem();
      return;
    }
  }, [state.ALA]);

  useEffect(() => {
    // 🔹 Log page view
    logEvent({
      event_type: "page_view",
      event_name: "Redeem",
      user_id: state?.userInfo?.user_id,
      session_id: state?.userInfo?.session_id,
    });
  }, []);

  useEffect(() => {
    if(states?.shiptoSearch && states?.shiptoSearch.length > 0) {
      handleShiptoSearch();
    }
  }, [states?.shiptoSearch])

  function handleShiptoSearch() {
    let obj = {
      loyaltyId: state.ALA.loyalty_id,
      searchValue: states?.shiptoSearch
    }
    setStates({shiptoLoading: true})
    getShiptoList(obj)
      .then(res => {
        if(res) {
          setStates({shiptoList: res?.data})
        }
      })
      .catch(err => {
        console.log({err});        
      })
    setStates({shiptoLoading: false})
  }

  // Billing Account api func
  const handleGetBillingAccountRedeem = async () => {
    try {
      setLoading(true);
      let values = state.ALA.loyalty_id;
      let res = await getBillingAccountRedeem(values);
      if (res) {
        setStates({
          billingAccount: res?.billingAccount,
          availableToRedeem: res?.availableToRedeem,
          pointsToDollor: res?.pointstodollor,
          maxRedemptionPoints: res?.maxRedemptionPoints
        });
        setLoading(false);
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };

  const handleGetBillingAccount = async () => {
    try {
      let values = state.ALA.loyalty_id;
      let res = await getBillingAccount(values);
      if (res) {
        dispatch({ type: 'SET_BILLINGACCOUNT', payload: res?.data });
        return;
      }
    } catch (e) {
      console.log({ e });
    }
  };
 
  console.log(state?.ACA?.customer_account_number,"comingshipto")
  useEffect(() => {
    if (state?.userInfo?.role_id === null) {
      setStates({ onewebshipto: state?.ALA?.selected_customer_account_number});
    } else {
      setStates({ onewebshipto: state?.ACA?.customer_account_number });
    }
  }, [state?.userInfo?.role_id, state?.billingAccount?.customer_account_number, state?.ACA?.customer_account_number]);

  async function handleRedeem() {
    try {
      let pointsRedeemed = states.pointsEntered;
      pointsRedeemed = pointsRedeemed.replace(/\,/g, '');
      if (state?.userInfo?.loyalty_organization_name == 'Henry Schein Dental' && pointsRedeemed < 200) {
        return setStates({
          errorText:
            'Value of your redemption request is too low for us to process. Please redeem points over 200 for each redemption request.',
          redeemBtnDisabled: false,
        });
      }
      if (state?.userInfo?.loyalty_organization_name == 'Henry Schein Canada' && pointsRedeemed < 1000) {
        return setStates({
          errorText:
            t('Value of your redemption request is too low for us to process. Please redeem points over 1000 for each redemption request'),
          redeemBtnDisabled: false,
        });
      }

      let body = {
        loyaltyId: state.ALA?.loyalty_id,
        redeemPoints: parseInt(pointsRedeemed),
        loyalty_organization_name:
          states.billingAccount?.loyalty_organization_name,
        loyalty_site_id: states.billingAccount?.loyalty_site_id,
        customer_billto_account_number: parseInt(
          states.billingAccount?.customer_account_number
        ),
        shipTo: states?.onewebshipto
      };
      console.log(body)
      let res = await confirmRedeem(body);
      if (res && res.type == 'success') {
        history.push({
          pathname: '/dashboard/redeem-confirmation',
          state: {
            redeemedPoints: res?.redeemedPoints,
            redeemedPointsDollar: states.pointsToDollor * res?.redeemedPoints,
            pointsBalance: res?.pointsBalance,
          },
        });
        return;
      } else if (res?.type?.toLowerCase() === 'error') {
        toast.error(
          res && res.message ? toastHandler(res) : t('Something Went Wrong'),
          toastCss
        );
        setStates({
          pointsEntered: '',
          dollorValue: 0,
          errorText: '',
          shiptoErrorText: '',
          redeemBtnDisabled: false,
        });
        return;
      }

      setStates({ redeemBtnDisabled: false });
      return;
    } catch (e) {
      console.log({ e });
    }
  }

  const toastHandler = (res) => {
    if (i18n.language == 'fr') {
      return res.french_message;
    } else {
      return res.message;
    }
  }

  const handlePointEntered = async (event) => {
    let value = event.target.value;
    value = value.replace(/\,/g, '');
    if (event.target.value === '') {
    }
    if (parseInt(value) > states.availableToRedeem) {
      setStates({
        errorText: t('Points must be less than available points'),
      });
    } else {
      setStates({
        pointsEntered: pointFormat(parseInt(value)),
        dollorValue: states.pointsToDollor * parseInt(value),
        errorText: '',
      });
    }
  };

  const pointFormat = (point) => {
    var nfObject = new Intl.NumberFormat('en-US');
    var res = nfObject.format(point);
    return res;
  };
  const isDisabled =
  Boolean(state?.ALA?.autoredemptionstatus)

  console.log(state?.ALA?.autoredemptionstatus,"disabled")
 
  

  return (
    <React.Fragment>
  {/** 🔴 AUTO-REDEMPTION DISABLED (DENTAL ONLY) */}
  {isDisabled &&
  state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
    <>
      <PointsCard loyaltyId={state?.ALA?.loyalty_id} showThriveUnlocked={false}/>

      <div className={classes.bronzenof}>
        {t(
          "The redemption button will be activated after the first auto-redemption. Thank you for your patience."
        )}
      </div>
    </>
  ) : state?.userInfo?.role_id == null &&
    state?.ALA?.["Loyalty_Account.tier"]?.toLowerCase() === "bronze" &&
    (state?.ACA?.signature_flag == null ||
      state?.ACA?.signature_flag === false) &&
    (state?.ACA?.startup_flag == null ||
      state?.ACA?.startup_flag === false) ? (
    <>
      <PointsCard loyaltyId={state?.ALA?.loyalty_id} showThriveUnlocked={false} />

      <div className={classes.bronzenof}>
        {t(
          i18n?.language === "fr" &&
            state?.userInfo?.loyalty_organization_name ===
              "Henry Schein Canada"
            ? "Atteignez le niveau Argent ou plus pour débloquer des échanges de points! Pour savoir comment y parvenir, consultez la rubrique «Voir mes avantages»."
            : "Reach Silver or higher to unlock point redemptions! See 'View my Benefits' for details on how to get there."
        )}
      </div>
    </>
  ) : (
    <>
      <GlobalCss />
      <PointsCard loyaltyId={state?.ALA?.loyalty_id} showThriveUnlocked={false} />

      {!loading &&
      states?.billingAccount &&
      Object.keys(states.billingAccount).length > 0 ? (
        <>
          <Grid container spacing={0} className={classes.cardParentGrid}>
            <Grid container spacing={0} className={classes.gridContainer}>
              <Grid item lg={12} className={classes.griTwo}>
                <div className={classes.divGrid}>
                  <div className={classes.gridDivFour}>
                    {t(states.billingAccount?.loyalty_organization_name)}
                  </div>

                  <div className={classes.gridDivFive}>
                    <div>
                      {t("Billing Account")}:{" "}
                      {states.billingAccount?.customer_account_number}
                    </div>
                    <div>
                      {t("Shipto Account")}: {states?.onewebshipto}
                    </div>
                  </div>

                  {state?.ALA?.["Loyalty_Account.loyalty_organization_name"] ===
                    "Henry Schein Dental" && (
                    <div className={classes.gridDivSix}>
                      {t("Available To Redeem")}:{" "}
                      <b>
                        {states.availableToRedeem > 0
                          ? pointFormat(states.availableToRedeem)
                          : 0}
                      </b>
                    </div>
                  )}

                  <div className={classes.gridDivSeven}>
                    {t("Enter total points to be redeemed")}
                  </div>

                  <ThemeProvider theme={formLabelsTheme}>
                    <TextField
                      required
                      variant="outlined"
                      className={classes.textField}
                      autoComplete="off"
                      value={states.pointsEntered}
                      onChange={(e) => {
                        if (isNaN(parseInt(e.target.value))) {
                          setStates({
                            pointsEntered: "",
                            dollorValue: 0,
                            errorText: "",
                          });
                          return;
                        }
                        handlePointEntered(e);
                      }}
                      error={states.errorText.length > 0}
                    />
                  </ThemeProvider>

                  {states.errorText.length > 0 && (
                    <div
                      style={{
                        color: "red",
                        width: "70%",
                        margin: "auto",
                      }}
                    >
                      {t(states.errorText)}
                    </div>
                  )}

                  <div className={classes.credit}>
                    {t("Credit Amount")} :{" "}
                    {currencyFormat(
                      states.dollorValue,
                      i18n.language,
                      state?.userInfo?.loyalty_organization_name
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} className={classes.textAlignCenter}>
              <Button
                className={classes.cancelBtn}
                onClick={() => history.push("/dashboard/dashboard")}
              >
                {t("Cancel")}
              </Button>

              <Button
                className={
                  state?.userInfo?.loyalty_organization_name ===
                  "Henry Schein Canada"
                    ? classes.redeemBtnca
                    : classes.redeemBtn
                }
                disabled={
                  states.pointsEntered <= 0 ||
                  states.redeemBtnDisabled
                }
                onClick={() => {
                  if (state?.userInfo?.editAction) {
                    setStates({ redeemBtnDisabled: true });
                    handleRedeem();
                  } else {
                    toast.error(state.userInfo?.editAccess);
                  }
                }}
              >
                {states.redeemBtnDisabled ? (
                  <div className="snippet">
                    <div className="stage">
                      <div className="dot-typing-e" />
                    </div>
                  </div>
                ) : (
                  t("Redeem").toUpperCase()
                )}
              </Button>
            </Grid>
          </Grid>
        </>
      ) : loading ? (
        <Loader Loading={true} top="15%" />
      ) : (
        <NoData currentTab="redeem" />
      )}
    </>
  )}
</React.Fragment>
  );
}
